import { Component, OnInit } from '@angular/core';
import {Roles} from "../../shared/authentication/auth.service";

@Component({
  selector: 'app-uber-admin-layout',
  templateUrl: './uber-admin-layout.component.html',
  styleUrls: ['./uber-admin-layout.component.scss']
})
export class UberAdminLayoutComponent implements OnInit {

    private roles = Roles;
    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/layout/uber-admin-layout/uber-admin-layout.component.ts